import { getParam } from '@amusnet/react-ui'
import { useConfigurationStore } from '@stores'

const Replay = () => {
    const gameHistoryApi = useConfigurationStore((state) => state.gameHistoryApi)
    const gameNumber = useConfigurationStore((state) => state.gin)
    const token = useConfigurationStore((state) => state.token)
    const language = useConfigurationStore((state) => state.language)
    const currency = useConfigurationStore((state) => state.currency)
    const gameHistoryUrl = useConfigurationStore((state) => state.gameHistoryUrl)

    const params = new URLSearchParams({
        api: gameHistoryApi,
        gin: gameNumber as unknown as string,
        token,
        lang: language,
        currency,
        cloudflareEnabled: (window.egtLibrary || window.amusnetLibrary).PIXILoader.shouldUseCloudflareImageOptimization,
        design: 'slot',
        baseUrl: getParam('baseUrl')?.trim(),
        skipWinAnimationsCoef: getParam('skipWinAnimationsCoef'),
        isReplayMode: 'true',
        // preview: 'true',
    })

    const iframeSrc = `${gameHistoryUrl}/?${params}`

    return (
        <div className="relative w-full h-full">
            <div
                id="gameHistoryIframe"
                className="absolute w-full h-full touch-none transform-gpu translate-x-0 translate-y-0 overflow-hidden"
            >
                <iframe src={iframeSrc} className="block touch-none w-full h-full border-none ml-2"></iframe>
            </div>
        </div>
    )
}

export default Replay
